import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getCategoryBySlug, getProductsByCategory } from '../data/productsData';
import './ProductsCategory.css';

const ProductsCategory = () => {
  const { category } = useParams();
  const categoryData = getCategoryBySlug(category);
  const products = getProductsByCategory(category);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [category]);

  if (!categoryData) {
    return (
      <div className="category-not-found">
        <h2>Category not found</h2>
        <Link to="/" className="back-home-btn">Go Back Home</Link>
      </div>
    );
  }

  return (
    <div className="products-category-page">
      {/* Category Banner */}
      <div className="category-banner">
        <div 
          className="category-banner-image"
          style={{ backgroundImage: `url(${categoryData.image})` }}
        >
          <div className="category-banner-overlay"></div>
          <div className="category-banner-content">
            <h1 className="category-title">{categoryData.name}</h1>
            <p className="category-description">{categoryData.description}</p>
          </div>
        </div>
      </div>

      {/* Products Grid Section */}
      <div className="products-section">
        <div className="products-container">
          <div className="products-header">
            <h2>Our Products</h2>
            <p>Explore our premium selection of {categoryData.name.toLowerCase()}</p>
          </div>

          <div className="products-grid">
            {products.map((product) => (
              <Link
                key={product.id}
                to={`/products/${category}/${product.id}`}
                className="product-card"
              >
                <div className="product-image-wrapper">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="product-image"
                  />
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description">{product.shortDescription}</p>
                </div>
              </Link>
            ))}
          </div>

          {products.length === 0 && (
            <div className="no-products">
              <p>No products available in this category yet.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductsCategory;
